module.exports = __webpack_public_path__ + "img/logobg2.7205b4ab.jpg";